import { createFileRoute } from '@tanstack/react-router';
import ComplianceDashboard from '@/components/features/compliance/components/compliance-dashboard';

export const Route = createFileRoute('/_authenticated/compliance/dashboard')({
  component: ComplianceDashboard,
});
